export default __webpack_public_path__ + "static/media/arrowgrey.d8ffc00c.svg";